import XLSX from "xlsx";
import { setCartCards, validateNumOrPin } from "../Card";
import * as a from "./action";
import { ERROR_EMUNS, LOADING_EMUNS, CARD_STATUS } from "./constant";
import { OPEN_ERROR_BOX } from "../../constants/actionTypes";

export const processSheet =
  (e, merchantList) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(a.setLoadingState(LOADING_EMUNS.LOADING));

      const file = e.target.files[0];
      const fileParts = file.name.split(".");
      const reader = new FileReader();

      if (!["csv", "xls", "xlsx"].includes(fileParts[fileParts.length - 1])) {
        throw new Error("invalid file");
      }

      reader.onload = async (e) => {
        const workBook = XLSX.read(e.target.result, { type: "binary" });
        const data = XLSX.utils
          .sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], {
            header: 1,
          })
          .filter((r) => r.length);
        const rows = data.slice(1, data.length);
        const cards = [];

        dispatch(a.setTotalUploadedCardsCount(rows.length));

        rows.forEach((card, idx) => {
          let formattedCard = {
            merchant: card[0]?.trim() ?? "",
            number: card[1]?.replace(/[^A-Za-z0-9]/g, "").trim() ?? "",
            pin:
              card[2]
                ?.toString()
                .replace(/[^A-z0-9]/g, "")
                .trim() ?? "",
            balance:
              card[3]?.toString().replace("$", "").replace(",", "").trim() ??
              "",
            refId: card[4]?.toString().trim() ?? "",
            error: "",
            idx: `spreadsheet[0][${idx}]`,
            status: CARD_STATUS.DEFAULT,
          };

          formattedCard.selectedMerchant = merchantList.find((merchant) => {
            let strippedMerchant = formattedCard.merchant
              .trim()
              .replace(/[^A-Za-z0-9]/g, "")
              .toLowerCase();

            let merchantName = merchant.name
              .trim()
              .replace(/[^A-Za-z0-9]/g, "")
              .toLowerCase();

            // needed for error cards to display merchant name in brand dropdown selection
            merchant.label = merchant.name;

            return (
              merchantName === strippedMerchant ||
              merchant.aliases.includes(strippedMerchant)
            );
          });

          if (!formattedCard.selectedMerchant) {
            formattedCard.error = "Please select a merchant";
          }

          if (formattedCard.selectedMerchant) {
            if (!formattedCard.balance) {
              formattedCard.error += " Balance is required";
            } else if (
              Number(formattedCard.balance) <
              Number(formattedCard.selectedMerchant.limit.min)
            ) {
              formattedCard.error +=
                " Balance is less than accepted minimum for this brand";
            } else if (
              Number(formattedCard.balance) >
              Number(formattedCard.selectedMerchant.limit.ma)
            ) {
              formattedCard.error +=
                " Balance is greater than accepted maximum for this brand";
            }

            if (formattedCard.number) {
              const { error, msg } = validateNumOrPin(
                "Gift Card Number",
                formattedCard.number,
                formattedCard.selectedMerchant.validation,
                0,
                true
              );

              if (error) {
                formattedCard.error += ` ${msg}`;
              }
            }

            if (formattedCard.pin) {
              const { error, msg } = validateNumOrPin(
                "Pin",
                formattedCard.pin,
                formattedCard.selectedMerchant.validation,
                1,
                true
              );

              if (error) {
                formattedCard.error += ` ${msg}`;
              }
            }
          }

          if (formattedCard.error !== "") {
            formattedCard.status = CARD_STATUS.ERROR;
          }

          if (formattedCard.error === "") {
            formattedCard.status = CARD_STATUS.VALID;
          }

          cards.push(formattedCard);
        });

        const validCards = cards.filter((c) => c.status === CARD_STATUS.VALID);
        const errorCards = cards.filter((c) => c.status === CARD_STATUS.ERROR);

        dispatch(a.setTotalErrorCardsCount(errorCards.length));
        dispatch(a.setTotalSuccessCardsCount(validCards.length));

        if (validCards.length === 0) {
          dispatch(a.setLoadingState(LOADING_EMUNS.ERROR));
          dispatch(a.setErrorType(ERROR_EMUNS.VALIDATION));
          dispatch(a.setErrorCards(errorCards));
        } else {
          try {
            const response = await remote(
              "post",
              `/v3/carts/${getState().Cart.cart.id}/cards`,
              {
                cards: validCards.map((c) => ({
                  enterValue: Number(c.balance),
                  merchantId: Number(c.selectedMerchant.id),
                  number: c.number,
                  pin: c.pin,
                  refId: c.refId,
                })),
              },
              "sendAllCards",
              dispatch
            );

            if (response.message) {
              throw response;
            }

            const { cards: serverCards, errors } = response;

            if (errorCards.length || errors.length) {
              const allErrs = [...errorCards];

              if (errors.length) {
                errors
                  .filter((c) => c.status.toUpperCase() === CARD_STATUS.ERROR)
                  .forEach((errCard) => {
                    cards.forEach((oCard) => {
                      if (
                        errCard.number === oCard.number &&
                        errCard.pin === oCard.pin
                      ) {
                        oCard.error = errCard.errMsg;

                        allErrs.push(oCard);
                      }
                    });
                  });
              }

              dispatch(a.setLoadingState(LOADING_EMUNS.ERROR));
              dispatch(a.setErrorType(ERROR_EMUNS.SERVER));
              dispatch(a.setErrorCards(allErrs));
              dispatch(setCartCards(serverCards));
            } else {
              dispatch(a.setLoadingState(LOADING_EMUNS.LOADED));
              dispatch(setCartCards(serverCards));
            }
          } catch (error) {
            dispatch(a.setLoadingState(LOADING_EMUNS.ERROR));
            dispatch({ type: OPEN_ERROR_BOX, payload: error });
          }
        }
      };

      reader.readAsBinaryString(file);
    } catch (e) {
      dispatch(a.setLoadingState(LOADING_EMUNS.ERROR));
      dispatch(a.setErrorType(ERROR_EMUNS.INVALID_FILE));
    }
  };
